<div
  class="inline-edit-cell"
  [class.is-editing]="isEditing"
  [class.hover-edit]="showEditOnHover"
>
  <ng-container *ngIf="!isEditing; else editMode">
    <ng-container *ngIf="displayAsTextbox; else displayMode">
      <kendo-textbox
        class="inline-edit-display w-100"
        [readonly]="true"
        [value]="value"
        [placeholder]="placeholder"
      ></kendo-textbox>
    </ng-container>
    <ng-template #displayMode>
      <ng-container *ngIf="displayAsDxTextbox; else textMode">
        <dx-text-box
          class="inline-edit-display"
          [readOnly]="true"
          [value]="value"
          [placeholder]="placeholder"
        ></dx-text-box>
      </ng-container>
      <ng-template #textMode>
        <span class="inline-edit-value" [title]="displayValue">{{ displayValue }}</span>
      </ng-template>
    </ng-template>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action inline-edit-trigger"
      (click)="startEdit()"
      [disabled]="!canEdit"
      aria-label="Edit"
    >
      <mat-icon>edit</mat-icon>
    </button>
  </ng-container>

  <ng-template #editMode>
    <ng-container *ngIf="displayAsTextbox; else dxEditMode">
      <kendo-textbox
        class="inline-edit-input w-100"
        [(ngModel)]="draftValue"
        [placeholder]="placeholder"
        [disabled]="isSaving"
        (keydown.enter)="save()"
        (keydown)="onKeyDown($event)"
      ></kendo-textbox>
    </ng-container>
    <ng-template #dxEditMode>
      <dx-text-box
        class="inline-edit-input"
        [(value)]="draftValue"
        [placeholder]="placeholder"
        [showClearButton]="true"
        [disabled]="isSaving"
        (onEnterKey)="save()"
        (onKeyDown)="onKeyDown($event)"
      ></dx-text-box>
    </ng-template>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action"
      (click)="save()"
      [disabled]="isSaving"
      aria-label="Save"
    >
      <mat-icon>check</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      class="inline-edit-action"
      (click)="cancelEdit()"
      [disabled]="isSaving"
      aria-label="Cancel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </ng-template>
</div>
